// extracted by mini-css-extract-plugin
module.exports = {"container":"image_container__3WvKQ","btn":"image_btn__CcDvj"};